var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "widgetContainer",
      class: {
        "full-screen-mode": _vm.fullScreenMode,
        "chat-visible": _vm.chatVisible,
      },
      attrs: { id: "chat-app" },
    },
    [
      _c(
        "div",
        {
          ref: "chatWrapperEl",
          staticClass: "chat-widget-wrapper",
          class: { visible: _vm.chatVisible, open: _vm.chatOpen },
        },
        [!_vm.loading && _vm.userLoaded ? _c("router-view") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "chatLaunchButtonEl",
          staticClass: "chat-launch-button-wrapper",
        },
        [
          _vm.totalUnreadChatMessages > 0
            ? _c("div", { staticClass: "chat-launch-message-count" }, [
                _c("span", { staticClass: "num" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.totalUnreadChatMessages) +
                      "\n      "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "chat-launch-button animated bounceIn",
              on: { click: _vm.toggleChat },
            },
            [
              _vm.chatOpen
                ? _c("div", { staticClass: "close-btn" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "14",
                          height: "14",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M13.978 12.637l-1.341 1.341L6.989 8.33l-5.648 5.648L0 12.637l5.648-5.648L0 1.341 1.341 0l5.648 5.648L12.637 0l1.341 1.341L8.33 6.989l5.648 5.648z",
                            "fill-rull": "evenodd",
                          },
                        }),
                      ]
                    ),
                  ])
                : _c("div", { staticClass: "open-btn" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "open-svg",
                        attrs: {
                          width: "24",
                          height: "24",
                          viewBox: "0 0 35 33",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M31.336 23.729l3.027 9.255h-17.13c-.243.01-.487.016-.733.016C7.387 33 0 25.613 0 16.5S7.387 0 16.5 0 33 7.387 33 16.5c0 2.593-.598 5.046-1.664 7.229zm-15.332-4.713h1.188c.264 0 .462-.154.462-.44v-.814c0-1.562 3.41-2.068 3.41-4.84 0-2.09-1.76-3.542-4.048-3.542-2.794 0-4.18 1.936-4.18 1.936-.132.176-.176.418 0 .572l.726.704c.176.154.352.154.528 0 .44-.374 1.144-1.32 2.706-1.32 1.276 0 1.98.792 1.98 1.694 0 2.024-3.19 2.31-3.19 4.708v.924c0 .242.198.418.418.418zm-.946 4.686c0 .836.682 1.518 1.518 1.518.858 0 1.54-.682 1.54-1.518a1.53 1.53 0 0 0-1.54-1.54c-.836 0-1.518.682-1.518 1.54z",
                            "fill-rull": "evenodd",
                          },
                        }),
                      ]
                    ),
                  ]),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/pages/Widgets/Chat/ChatApp/template.html?vue&type=template&id=9e28a20e&
// module id = 1092
// module chunks = 0